import { Radio, RadioProps } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { useStyles } from "./styles";

export const CustomRadio = (props: RadioProps) => {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
};
